module.exports = __webpack_public_path__ + "media/svg/nav-voltar-5ead6ec5.svg";